import { useState } from 'react'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Link, List } from '@/ui'
import { mtc, TextColors } from '@/styles'
import { useAdviserAnalytics } from '../analytics'
import type { CitationSource } from '../lib/types'

interface CitationCardProps {
  sources: CitationSource[]
}

export const CitationCard = ({ sources }: CitationCardProps) => {
  const [expanded, setExpanded] = useState(false)
  const { trackSourceClicked } = useAdviserAnalytics()

  if (sources.length === 0) return null

  return (
    <div className="mt-2">
      <button
        onClick={() => setExpanded(!expanded)}
        className={mtc(
          'flex items-center gap-1.5 text-xs text-neutral-500',
          'hover:text-neutral-700 transition-colors cursor-pointer',
          'bg-transparent border-none p-0'
        )}
      >
        <Icon
          icon={faChevronRight}
          className={mtc(
            'text-[10px] transition-transform duration-200',
            expanded && 'rotate-90'
          )}
        />
        View sources ({sources.length})
      </button>
      {expanded && (
        <List className="mt-1.5 space-y-1 pl-4 list-none">
          {sources.map((source, i) => (
            <List.Item key={`${source.url}-${source.title}`} className="m-0">
              <Link
                href={`${source.url}${source.url.includes('?') ? '&' : '?'}utm_source=heard-ai`}
                newPage
                color={TextColors.MUTED}
                variant="primary"
                className="text-xs inline-flex items-center gap-1"
                onClick={() =>
                  trackSourceClicked({
                    articleId: source.articleId ?? null,
                    articleUrl: source.url,
                    position: i + 1,
                  })
                }
              >
                {i + 1}. {source.title}
                <Icon
                  icon={faArrowUpRightFromSquare}
                  className="text-[10px] shrink-0"
                />
              </Link>
            </List.Item>
          ))}
        </List>
      )}
    </div>
  )
}
